const DEFAULT_BASE_URL = 'https://localhost:7278';

let appSettings = {
  baseUrl: DEFAULT_BASE_URL,
  webBaseUrl: DEFAULT_BASE_URL,
};

const pickUrl = (data, keys) => {
  for (const key of keys) {
    const parts = key.split('.');
    let cur = data;
    for (const part of parts) {
      if (cur == null || typeof cur !== 'object') {
        cur = undefined;
        break;
      }
      cur = cur[part];
    }
    if (cur != null && String(cur).trim()) {
      return String(cur).trim().replace(/\/$/, '');
    }
  }
  return '';
};

export const loadAppSettings = async () => {
  try {
    const response = await fetch(`${process.env.PUBLIC_URL || ''}/appsettings.json`, {
      cache: 'no-store',
    });

    if (!response.ok) {
      return appSettings;
    }

    const data = await response.json();
    const baseUrl = pickUrl(data, ['baseUrl', 'Api.BaseUrl', 'api.baseUrl', 'ApiBaseUrl']);
    const webBaseUrl =
      pickUrl(data, ['webBaseUrl', 'Web.BaseUrl', 'web.baseUrl', 'WebBaseUrl']) || baseUrl;

    appSettings = {
      ...appSettings,
      ...(baseUrl ? { baseUrl } : {}),
      ...(webBaseUrl ? { webBaseUrl } : {}),
    };
  } catch {
    // Keep default base URL when appsettings.json is missing or invalid.
  }

  return appSettings;
};

export const getBaseUrl = () => appSettings.baseUrl || DEFAULT_BASE_URL;

/** SignalR hub host. Falls back to Api baseUrl when webBaseUrl is empty. */
export const getWebBaseUrl = () =>
  appSettings.webBaseUrl || appSettings.baseUrl || DEFAULT_BASE_URL;

export const getAppSettings = () => ({ ...appSettings });

export default appSettings;
